import { customElement } from "lit/decorators.js";
import { SvgIconElement } from "../common/svg-icon-element.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let MenuActionIconIcon = class extends SvgIconElement {
  render() {
    return this.renderIcon({
      template: '<path d="M3.25 8.75c1.795 0 3.25 1.455 3.25 3.25s-1.455 3.25-3.25 3.25S0 13.795 0 12s1.455-3.25 3.25-3.25zm8.75 0c1.795 0 3.25 1.455 3.25 3.25s-1.455 3.25-3.25 3.25S8.75 13.795 8.75 12 10.205 8.75 12 8.75zm8.75 0C22.545 8.75 24 10.205 24 12s-1.455 3.25-3.25 3.25S17.5 13.795 17.5 12s1.455-3.25 3.25-3.25z"/>',
      viewBox: [0, 0, 24, 24]
    });
  }
};
MenuActionIconIcon = __decorateClass([
  customElement("elm-menu-action-icon-icon")
], MenuActionIconIcon);
export { MenuActionIconIcon };
